// All UI strings across supported languages.
// Keys: navbar, common, landing, login, register, dashboard, intentions, special, group, warriors, liturgical, testimonies, admin, psalms, footer.

const en = {
    nav: {
        intentions: "Intentions",
        special: "Special Requests",
        group: "Group Prayers",
        psalms: "Psalms",
        liturgical: "Daily Readings",
        testimonies: "Angels on Earth",
        dashboard: "Dashboard",
        profile: "My Profile",
        moderator: "Moderator",
        signin: "Sign in",
        join: "Join",
        language: "Language",
        logout: "Sign out",
    },
    profile: {
        h: "My Profile",
        kicker: "Your account",
        sub: "Update your details and prayer hour. Change your password any time.",
        name: "Full name",
        email: "Email",
        prayer_time: "Prayer hour",
        is_warrior: "Prayer Warrior status",
        warrior_yes: "Enrolled",
        warrior_no: "Not enrolled",
        save: "Save changes",
        saved: "Saved.",
        pw_h: "Change password",
        pw_current: "Current password",
        pw_new: "New password (min 6)",
        pw_submit: "Update password",
        pw_ok: "Password updated.",
        warrior_bio_h: "Warrior bio & photo",
        warrior_bio_sub: "A short introduction for others — shown on the Top Warriors section when highlighted.",
        bio: "A short bio (max 500)",
        upload_photo: "Upload photo",
        uploading: "Uploading…",
        change_photo: "Change photo",
        photo_hint: "JPG, PNG or WEBP · max 5MB",
    },
    topwarriors: {
        kicker: "Our Prayer Warriors",
        h: "The faithful who carry your intentions",
        sub: "Men and women of prayer committed to a daily hour for the needs of the community.",
        prayers: "prayers offered",
        cta: "Join them — become a Warrior",
    },
    invite: {
        btn: "Invite",
        title: "Invite to this group prayer",
        sub: "Share a link or send email invitations.",
        link_label: "Shareable link",
        copy: "Copy",
        copied: "Copied!",
        emails_label: "Emails (comma separated)",
        message_label: "A short note (optional)",
        send: "Send invitations",
        sent: "Invitations sent.",
        close: "Close",
    },
    common: {
        salesian: "Global Christ Mission",
        loading: "Loading…",
        readAll: "Mark all read",
        noNotifs: "No notifications yet.",
        notifications: "Notifications",
        submit: "Submit",
        cancel: "Cancel",
        save: "Save",
    },
    landing: {
        kicker: "· A Catholic Prayer Portal ·",
        h1_a: "Someone to help you.",
        h1_b: "Someone to",
        h1_b_em: "pray",
        h1_b2: "for you.",
        h1_c: "Someone to listen.",
        subtitle: "Share your intention. A community of Prayer Warriors will carry it before the Lord — through the Rosary, the Holy Mass, Adoration, and the Divine Mercy. When the Lord grants the favour, come tell us, and we shall give thanks together.",
        cta_warriors: "Join the Prayer Warriors",
        cta_ask: "Ask for Prayer",
        stats_categories: "Intention categories",
        stats_praying: "Someone praying",
        stats_goodness: "God’s goodness",
        general_kicker: "General Intentions",
        general_h: "What shall we pray for today?",
        general_sub: "Pick one of the common intentions, or write your own. Your request joins the others already being carried in prayer.",
        open_board: "Open the board",
        write_own: "+ Write your own",
        special_kicker: "The Special Request Model",
        special_h: "Request a particular form of prayer.",
        special_sub: "For those who wish to be remembered in a specific devotion.",
        special_novenas_note: "Novenas offered to the Blessed Virgin Mary, the Infant Jesus, St Joseph, and St Antony.",
        special_cta: "Submit a special request",
        warriors_kicker: "Prayer Warriors",
        warriors_h: "Choose your hour. Pray. Notify the centre.",
        warriors_sub: "Members commit a time of the day — dawn, noon, or evening — and pray the intentions entrusted to them. The Requester is strengthened by the knowledge that someone, somewhere, is remembering them.",
        warriors_a: "Join the group",
        warriors_a_d: "Receive guidance & membership.",
        warriors_b: "Choose your time",
        warriors_b_d: "Dawn, midday, evening.",
        warriors_c: "Pray & notify",
        warriors_c_d: "Strengthen the requester.",
        warriors_cta: "Become a Prayer Warrior",
        angels_kicker: "Angels on Earth",
        angels_h: "For Praise & Worship.",
        angels_sub: "When the intention is fulfilled, a witness of thanksgiving is offered. Continued adoration of the Holy Eucharist, the Rosary for young people and children — a heart that never stops thanking.",
        angels_cta: "Read testimonies",
        note_title: "A note from the Mission",
        note_body: "“Ask and you shall receive, seek and you shall find, knock and it shall be opened.” — Mt 7:7",
    },
    login: {
        h: "Welcome back",
        sub: "Sign in to carry another’s intention in prayer today.",
        email: "Email or mobile number",
        password: "Password",
        submit: "Sign in",
        submitting: "Signing in…",
        new: "New here?",
        new_link: "Join the Prayer Warriors",
        forgot: "Forgot password?",
        signup_mobile: "Sign up with mobile",
    },
    register: {
        h: "Join us in prayer",
        sub: "Create an account to request, pray, and give thanks with the community.",
        name: "Full Name",
        email: "Email",
        phone: "Mobile (with country code)",
        or: "or",
        password: "Password (min 6)",
        submit: "Create account",
        submitting: "Creating account…",
        have: "Already a member?",
        have_link: "Sign in",
        phone_hint: "e.g. +91 98765 43210",
    },
    forgot: {
        h: "Forgot your password?",
        sub: "Enter your email and we'll send you a reset link.",
        email: "Email",
        submit: "Send reset link",
        sent: "If an account exists for this email, a reset link has been sent.",
        back: "← Back to sign in",
        reset_h: "Set a new password",
        reset_sub: "Choose a strong password with at least 6 characters.",
        new_password: "New password",
        reset_submit: "Update password",
        reset_ok: "Password updated. Redirecting to sign in…",
    },
    dash: {
        to_pray_h: "Intentions entrusted to you",
        to_pray_sub: "Pray for these today, dear warrior.",
        to_pray_empty: "You've prayed for every open intention today. Come back tomorrow.",
        pray_btn: "I've prayed",
    },
    priority: {
        kicker: "Priority prayers",
        h: "Pray for these today",
        sub: "Intentions being lifted up by many warriors right now — join your prayer with theirs.",
        pinned: "Featured",
        cta: "I'm praying",
        cta_signin: "Sign in to pray",
        share_wa: "Share on WhatsApp",
        committed_one: "1 warrior committed",
        committed_many: "{{count}} warriors committed",
    },
    psalms: {
        h: "The Book of Psalms",
        kicker: "Pray through the Psalms",
        sub: "One hundred and fifty Psalms — the prayer of Israel and of the Church. Pray them individually or with the community.",
        today: "Psalm of the Day",
        all: "All Psalms",
        theme: "Theme",
        search: "Search by number, title, or word…",
        pray: "I prayed this Psalm",
        prayed: "You prayed Psalm",
        count: "times prayed",
        back: "← All Psalms",
    },
    footer: {
        tagline: "A Catholic Prayer Portal — organised by the Global Christ Mission for the Department of Catechism and Evangelisation, Pondicherry Region.",
        someone_h: "Someone to",
        someone_1: "Help you",
        someone_2: "Pray for you",
        someone_3: "Listen to you",
        communion_h: "In communion",
        communion_body: "With the guidance of the Provincial and local authorities of the Diocese. For faith formation, particularly for young people.",
        thanks_h: "With grateful hearts",
        thanks_body: "Heartfelt thanks to our volunteers, sponsors, and supporters whose generosity, prayers, and quiet labour make this mission possible. May the Lord bless and reward each of you a hundredfold.",
        copy: "© 2026 The Prayer Warriors — Global Christ Mission",
        made_with: "Built with",
        for_faithful: "for the faithful",
    },
};

const ta = {
    nav: {
        intentions: "விண்ணப்பங்கள்",
        special: "சிறப்பு வேண்டுதல்கள்",
        group: "குழு ஜெபம்",
        psalms: "சங்கீதங்கள்",
        liturgical: "அன்றைய வாசகம்",
        testimonies: "புவியின் தூதர்கள்",
        dashboard: "என் பக்கம்",
        profile: "என் சுயவிவரம்",
        moderator: "ஒழுங்கமைப்பாளர்",
        signin: "உள்நுழை",
        join: "இணை",
        language: "மொழி",
        logout: "வெளியேறு",
    },
    profile: {
        h: "என் சுயவிவரம்",
        kicker: "உங்கள் கணக்கு",
        sub: "உங்கள் விவரங்களையும் ஜெப நேரத்தையும் புதுப்பியுங்கள். கடவுச்சொல்லை எப்போது வேண்டுமானாலும் மாற்றுங்கள்.",
        name: "முழு பெயர்",
        email: "மின்னஞ்சல்",
        prayer_time: "ஜெப நேரம்",
        is_warrior: "ஜெப வீரர் நிலை",
        warrior_yes: "சேர்ந்துள்ளீர்கள்",
        warrior_no: "சேரவில்லை",
        save: "மாற்றங்களை சேமி",
        saved: "சேமிக்கப்பட்டது.",
        pw_h: "கடவுச்சொல் மாற்று",
        pw_current: "தற்போதைய கடவுச்சொல்",
        pw_new: "புதிய கடவுச்சொல் (குறைந்தது 6)",
        pw_submit: "கடவுச்சொல் புதுப்பி",
        pw_ok: "கடவுச்சொல் புதுப்பிக்கப்பட்டது.",
    },
    invite: {
        btn: "அழை",
        title: "இந்த குழு ஜெபத்திற்கு அழை",
        sub: "இணைப்பை பகிரவும் அல்லது மின்னஞ்சல் அழைப்பிதழ் அனுப்பவும்.",
        link_label: "பகிர்வு இணைப்பு",
        copy: "நகலெடு",
        copied: "நகலெடுக்கப்பட்டது!",
        emails_label: "மின்னஞ்சல்கள் (கமா பிரிக்கப்பட்டவை)",
        message_label: "ஒரு குறிப்பு (விருப்பம்)",
        send: "அழைப்புகளை அனுப்பு",
        sent: "அழைப்புகள் அனுப்பப்பட்டன.",
        close: "மூடு",
    },
    common: {
        salesian: "குளோபல் கிறிஸ்து மிஷன்",
        loading: "ஏற்றுகிறது…",
        readAll: "அனைத்தையும் படித்ததாகக் குறி",
        noNotifs: "அறிவிப்புகள் இல்லை.",
        notifications: "அறிவிப்புகள்",
        submit: "சமர்ப்பி",
        cancel: "ரத்து",
        save: "சேமி",
    },
    landing: {
        kicker: "· ஒரு கத்தோலிக்க ஜெப வலைத்தளம் ·",
        h1_a: "உங்களுக்கு உதவ ஒருவர்.",
        h1_b: "உங்களுக்காக",
        h1_b_em: "ஜெபிக்க",
        h1_b2: "ஒருவர்.",
        h1_c: "கேட்க ஒருவர்.",
        subtitle: "உங்கள் விண்ணப்பத்தை பகிருங்கள். ஜெப வீரர்கள் சமூகம் அதை ஜெப மாலை, திருப்பலி, ஆராதனை, இரக்கத்தின் ஜெபம் வழியாக ஆண்டவர் முன் எடுத்துச் செல்வார்கள். ஆண்டவர் அருள் செய்தபின் எங்களிடம் சொல்லுங்கள்; ஒன்றாக நன்றி சொல்வோம்.",
        cta_warriors: "ஜெப வீரர்களில் சேருங்கள்",
        cta_ask: "ஜெபம் கேளுங்கள்",
        stats_categories: "விண்ணப்ப வகைகள்",
        stats_praying: "யாரோ ஜெபிக்கிறார்",
        stats_goodness: "இறையின் நன்மை",
        general_kicker: "பொது விண்ணப்பங்கள்",
        general_h: "இன்று நாம் எதற்காக ஜெபிக்கலாம்?",
        general_sub: "பொதுவான விண்ணப்பங்களில் ஒன்றை தேர்வு செய்யுங்கள், அல்லது உங்கள் சொந்த விண்ணப்பத்தை எழுதுங்கள்.",
        open_board: "பலகையை திற",
        write_own: "+ உங்கள் விண்ணப்பம்",
        special_kicker: "சிறப்பு வேண்டுதல்",
        special_h: "ஒரு குறிப்பிட்ட வழியில் ஜெபிக்கக் கேளுங்கள்.",
        special_sub: "ஒரு குறிப்பிட்ட பக்தி வழியில் நினைவு கூற விரும்புபவர்களுக்கு.",
        special_novenas_note: "அன்னை மரியாள், குழந்தை இயேசு, புனித ஜோசப், புனித அந்தோணியாருக்கு நவநாட் ஜெபம்.",
        special_cta: "சிறப்பு வேண்டுதல் சமர்ப்பி",
        warriors_kicker: "ஜெப வீரர்கள்",
        warriors_h: "உங்கள் மணியை தேர்ந்தெடுங்கள். ஜெபியுங்கள். அறிவியுங்கள்.",
        warriors_sub: "உறுப்பினர்கள் நாளின் ஒரு நேரத்தை — விடியல், நண்பகல், மாலை — அளிக்கிறார்கள். விண்ணப்பம் கொடுத்தவர் அறிவார்: யாரோ, எங்காவது, அவரை நினைக்கிறார்.",
        warriors_a: "குழுவில் சேருங்கள்",
        warriors_a_d: "வழிகாட்டுதலும் உறுப்பினரமும்.",
        warriors_b: "நேரம் தேர்வு",
        warriors_b_d: "விடியல், நண்பகல், மாலை.",
        warriors_c: "ஜெபி & அறிவி",
        warriors_c_d: "விண்ணப்பம் கொடுத்தவரை பலப்படுத்து.",
        warriors_cta: "ஜெப வீரர் ஆக",
        angels_kicker: "புவியின் தூதர்கள்",
        angels_h: "துதிக்கும் வணக்கத்திற்காக.",
        angels_sub: "விண்ணப்பம் நிறைவேறியபின், நன்றியின் சாட்சி அளிக்கப்படுகிறது. திரு பலிப் பொருள் ஆராதனை, இளையோர் சிறார்களுக்கான ஜெப மாலை — நன்றி நிற்காத இதயம்.",
        angels_cta: "சாட்சிகளை வாசியுங்கள்",
        note_title: "மிஷன் குறிப்பு",
        note_body: "“கேளுங்கள், உங்களுக்குக் கொடுக்கப்படும்.” — மத் 7:7",
    },
    priority: {
        kicker: "முக்கிய ஜெபங்கள்",
        h: "இன்று இவற்றுக்காக ஜெபியுங்கள்",
        sub: "இப்போது பல ஜெப வீரர்களால் ஏறெடுக்கப்படும் விண்ணப்பங்கள் — உங்கள் ஜெபத்தையும் சேருங்கள்.",
        pinned: "சிறப்பு",
        cta: "நான் ஜெபிக்கிறேன்",
        cta_signin: "ஜெபிக்க உள்நுழை",
        share_wa: "வாட்ஸ்அப் மூலம் பகிர்",
        committed_one: "1 வீரர் இணைந்துள்ளார்",
        committed_many: "{{count}} வீரர்கள் இணைந்துள்ளனர்",
    },
    topwarriors: {
        kicker: "நமது ஜெப வீரர்கள்",
        h: "விண்ணப்பங்களை சுமக்கும் விசுவாசிகள்",
        sub: "சமூகத்தின் தேவைகளுக்காக தினமும் ஒரு மணிநேரம் ஜெபிக்கும் ஆண்களும் பெண்களும்.",
        prayers: "ஜெபங்கள் ஒப்புக்கொடுக்கப்பட்டன",
        cta: "ஜெப வீரர் ஆகுங்கள்",
    },
    login: {
        h: "மீண்டும் வரவேற்கிறோம்",
        sub: "இன்று இன்னொருவரின் விண்ணப்பத்தை ஜெபத்தில் சுமக்க உள்நுழையுங்கள்.",
        email: "மின்னஞ்சல்",
        password: "கடவுச்சொல்",
        submit: "உள்நுழை",
        submitting: "உள்நுழைகிறது…",
        new: "புதியவர்?",
        new_link: "ஜெப வீரர்களில் சேருங்கள்",
    },
    register: {
        h: "ஜெபத்தில் எங்களோடு சேருங்கள்",
        sub: "விண்ணப்பிக்க, ஜெபிக்க, நன்றி சொல்ல கணக்கு உருவாக்குங்கள்.",
        name: "முழு பெயர்",
        email: "மின்னஞ்சல்",
        password: "கடவுச்சொல் (குறைந்தது 6)",
        submit: "கணக்கு உருவாக்கு",
        submitting: "உருவாக்கப்படுகிறது…",
        have: "ஏற்கனவே உறுப்பினரா?",
        have_link: "உள்நுழை",
    },
    psalms: {
        h: "சங்கீத நூல்",
        kicker: "சங்கீதங்கள் வழியாக ஜெபி",
        sub: "நூற்று ஐம்பது சங்கீதங்கள் — இஸ்ரவேலின், திருச்சபையின் ஜெபம்.",
        today: "இன்றைய சங்கீதம்",
        all: "அனைத்து சங்கீதங்கள்",
        theme: "கருத்து",
        search: "எண், தலைப்பு, வார்த்தை…",
        pray: "இந்த சங்கீதத்தை ஜெபித்தேன்",
        prayed: "நீங்கள் ஜெபித்த சங்கீதம்",
        count: "முறை ஜெபிக்கப்பட்டது",
        back: "← அனைத்து சங்கீதங்கள்",
    },
    footer: {
        tagline: "ஒரு கத்தோலிக்க ஜெப வலைத்தளம் — குளோபல் கிறிஸ்து மிஷன், புதுச்சேரி பகுதி.",
        someone_h: "உங்களுக்கு",
        someone_1: "உதவ ஒருவர்",
        someone_2: "ஜெபிக்க ஒருவர்",
        someone_3: "கேட்க ஒருவர்",
        communion_h: "ஒற்றுமையில்",
        communion_body: "மாநிலத் தலைவர் மற்றும் மறைமாவட்ட அதிகாரிகளின் வழிகாட்டுதலுடன். இளையோரின் விசுவாச உருவாக்கத்திற்காக.",
        thanks_h: "நன்றி நிறைந்த இதயங்களுடன்",
        thanks_body: "எங்கள் தன்னார்வலர்கள், ஆதரவாளர்கள் மற்றும் பங்களிப்பாளர்களுக்கு மனமார்ந்த நன்றி — அவர்களின் தாராளமும், ஜெபங்களும், அமைதியான உழைப்பும் இந்த பணியை சாத்தியமாக்குகின்றன. ஆண்டவர் ஒவ்வொருவரையும் நூறு மடங்காக ஆசிர்வதிப்பாராக.",
        copy: "© 2026 தி பிரேயர் வாரியர்ஸ் — குளோபல் கிறிஸ்து மிஷன்",
        made_with: "உருவாக்கப்பட்டது",
        for_faithful: "விசுவாசிகளுக்காக",
    },
};

const fr = {
    nav: {
        intentions: "Intentions",
        special: "Demandes spéciales",
        group: "Prières en groupe",
        psalms: "Psaumes",
        liturgical: "Lectures du jour",
        testimonies: "Anges sur la Terre",
        dashboard: "Tableau de bord",
        profile: "Mon profil",
        moderator: "Modérateur",
        signin: "Connexion",
        join: "Rejoindre",
        language: "Langue",
        logout: "Se déconnecter",
    },
    profile: {
        h: "Mon profil",
        kicker: "Votre compte",
        sub: "Mettez à jour vos informations et votre heure de prière. Changez votre mot de passe à tout moment.",
        name: "Nom complet",
        email: "Courriel",
        prayer_time: "Heure de prière",
        is_warrior: "Statut Guerrier de Prière",
        warrior_yes: "Inscrit",
        warrior_no: "Non inscrit",
        save: "Enregistrer les modifications",
        saved: "Enregistré.",
        pw_h: "Changer le mot de passe",
        pw_current: "Mot de passe actuel",
        pw_new: "Nouveau mot de passe (min. 6)",
        pw_submit: "Mettre à jour",
        pw_ok: "Mot de passe mis à jour.",
    },
    invite: {
        btn: "Inviter",
        title: "Inviter à cette prière de groupe",
        sub: "Partagez un lien ou envoyez des invitations par courriel.",
        link_label: "Lien partageable",
        copy: "Copier",
        copied: "Copié !",
        emails_label: "Courriels (séparés par virgule)",
        message_label: "Un petit mot (optionnel)",
        send: "Envoyer les invitations",
        sent: "Invitations envoyées.",
        close: "Fermer",
    },
    common: {
        salesian: "Mission Global Christ",
        loading: "Chargement…",
        readAll: "Tout marquer comme lu",
        noNotifs: "Aucune notification.",
        notifications: "Notifications",
        submit: "Envoyer",
        cancel: "Annuler",
        save: "Enregistrer",
    },
    landing: {
        kicker: "· Un portail catholique de prière ·",
        h1_a: "Quelqu’un pour vous aider.",
        h1_b: "Quelqu’un pour",
        h1_b_em: "prier",
        h1_b2: "pour vous.",
        h1_c: "Quelqu’un pour vous écouter.",
        subtitle: "Partagez votre intention. Une communauté de Guerriers de Prière la portera devant le Seigneur — par le Rosaire, la Sainte Messe, l’Adoration et la Divine Miséricorde. Quand le Seigneur accordera la grâce, venez nous le dire, et nous rendrons grâce ensemble.",
        cta_warriors: "Rejoindre les Guerriers de Prière",
        cta_ask: "Demander une prière",
        stats_categories: "Catégories d’intentions",
        stats_praying: "Quelqu’un prie",
        stats_goodness: "Bonté de Dieu",
        general_kicker: "Intentions générales",
        general_h: "Pour quoi prier aujourd’hui ?",
        general_sub: "Choisissez une intention commune, ou écrivez la vôtre. Votre demande rejoint les autres déjà portées dans la prière.",
        open_board: "Ouvrir le tableau",
        write_own: "+ Écrire la vôtre",
        special_kicker: "Le modèle de demande spéciale",
        special_h: "Demandez une forme particulière de prière.",
        special_sub: "Pour ceux qui désirent être confiés à une dévotion précise.",
        special_novenas_note: "Neuvaines à la Bienheureuse Vierge Marie, à l’Enfant Jésus, à saint Joseph et à saint Antoine.",
        special_cta: "Soumettre une demande spéciale",
        warriors_kicker: "Guerriers de Prière",
        warriors_h: "Choisissez votre heure. Priez. Avertissez le centre.",
        warriors_sub: "Les membres s’engagent sur un moment de la journée — aube, midi, soir — et prient les intentions qui leur sont confiées. Celui qui demande est fortifié de savoir que quelqu’un, quelque part, se souvient de lui.",
        warriors_a: "Rejoindre le groupe",
        warriors_a_d: "Recevoir l’accompagnement.",
        warriors_b: "Choisir votre heure",
        warriors_b_d: "Aube, midi, soir.",
        warriors_c: "Prier & avertir",
        warriors_c_d: "Fortifier le demandeur.",
        warriors_cta: "Devenir un Guerrier de Prière",
        angels_kicker: "Anges sur la Terre",
        angels_h: "Pour la louange et l’adoration.",
        angels_sub: "Quand l’intention est exaucée, un témoignage de reconnaissance est offert. Adoration continue du Saint-Sacrement, Rosaire pour les jeunes et les enfants — un cœur qui ne cesse de remercier.",
        angels_cta: "Lire les témoignages",
        note_title: "Un mot de la Mission",
        note_body: "« Demandez, et l’on vous donnera ; cherchez, et vous trouverez ; frappez, et l’on vous ouvrira. » — Mt 7,7",
    },
    priority: {
        kicker: "Prières prioritaires",
        h: "Priez pour celles-ci aujourd’hui",
        sub: "Intentions portées en ce moment par de nombreux guerriers — unissez votre prière à la leur.",
        pinned: "En avant",
        cta: "Je prie",
        cta_signin: "Connectez-vous pour prier",
        share_wa: "Partager sur WhatsApp",
        committed_one: "1 guerrier engagé",
        committed_many: "{{count}} guerriers engagés",
    },
    topwarriors: {
        kicker: "Nos Guerriers de Prière",
        h: "Les fidèles qui portent vos intentions",
        sub: "Des hommes et des femmes de prière, engagés chaque jour pour les besoins de la communauté.",
        prayers: "prières offertes",
        cta: "Rejoindre — devenir un Guerrier",
    },
    login: {
        h: "Heureux de vous revoir",
        sub: "Connectez-vous pour porter l’intention d’un autre dans la prière aujourd’hui.",
        email: "Courriel",
        password: "Mot de passe",
        submit: "Connexion",
        submitting: "Connexion…",
        new: "Nouveau ici ?",
        new_link: "Rejoindre les Guerriers de Prière",
    },
    register: {
        h: "Rejoignez-nous dans la prière",
        sub: "Créez un compte pour demander, prier et rendre grâce avec la communauté.",
        name: "Nom complet",
        email: "Courriel",
        password: "Mot de passe (min. 6)",
        submit: "Créer un compte",
        submitting: "Création…",
        have: "Déjà membre ?",
        have_link: "Connexion",
    },
    psalms: {
        h: "Le Livre des Psaumes",
        kicker: "Prier avec les Psaumes",
        sub: "Cent cinquante Psaumes — la prière d’Israël et de l’Église. Seul ou en communauté.",
        today: "Psaume du jour",
        all: "Tous les Psaumes",
        theme: "Thème",
        search: "Chercher par numéro, titre ou mot…",
        pray: "J’ai prié ce Psaume",
        prayed: "Vous avez prié le Psaume",
        count: "fois prié",
        back: "← Tous les Psaumes",
    },
    footer: {
        tagline: "Un portail catholique de prière — organisé par la Mission Global Christ pour le département de catéchèse et d’évangélisation, région de Pondichéry.",
        someone_h: "Quelqu’un pour",
        someone_1: "Vous aider",
        someone_2: "Prier pour vous",
        someone_3: "Vous écouter",
        communion_h: "En communion",
        communion_body: "Avec la guidance du Provincial et des autorités locales du Diocèse. Pour la formation de la foi, particulièrement pour les jeunes.",
        thanks_h: "Avec un cœur reconnaissant",
        thanks_body: "Un grand merci à nos bénévoles, donateurs et soutiens — leur générosité, leurs prières et leur travail discret rendent cette mission possible. Que le Seigneur vous bénisse et vous récompense au centuple.",
        copy: "© 2026 The Prayer Warriors — Mission Global Christ",
        made_with: "Fait avec",
        for_faithful: "pour les fidèles",
    },
};

export const resources = {
    en: { translation: en },
    ta: { translation: ta },
    fr: { translation: fr },
};

export const languages = [
    { code: "en", label: "English", native: "English" },
    { code: "ta", label: "Tamil", native: "தமிழ்" },
    { code: "fr", label: "French", native: "Français" },
];
